//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/NXObject.js";
let d=[[],[[["port_1","port_2"],"GetPorts",{},0,0],[["port_1","port_2"],"SetPorts",{},2,0],[[],"GetEngagement",{R_:{engagement:''}},0,0],[["engagement"],"SetEngagement",{},1,0],[[],"IsValid",{R_:{validity:''}},0,0],[[],"ArePortsAligned",{R_:{alignment:''}},0,0],[["overridden_validity"],"OverrideValidity",{},1,0],[[],"GetOverrideReason",{R_:{reason:''}},0,0],[["reason"],"SetOverrideReason",{},1,0],[[],"GetOverriddenValidity",{R_:{overridden_validity:''}},0,0],[["reason"],"ForceValid",{},1,0],[[],"RemoveForcedValidity",{},0,0],[[],"IsForcedValid",{R_:{forced_valid:''}},0,0]],[]];
SPLM.Routing.PortConnection = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.PortConnection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.PortConnection.OverriddenValidity = Object.freeze({
    "None" : "None", "Valid" : "Valid", "Invalid" : "Invalid"});

export default SPLM;